// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"22457338","977":"e8f4549f"}[chunkId] + ".chunk.js";
};